/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class SemanticVersioning {
    #major = 0;
    #minor = 0;
    #patch = 1;
    constructor(version) {
        if (!version) {
            return;
        }
        this.version = version;
    }
    get version() {
        return `${this.#major}.${this.#minor}.${this.#patch}`;
    }
    set version(version) {
        const match = /^(\d+)\.(\d+)\.(\d+)$/.exec(version);
        if (!match) {
            throw new Error(`Version "${version}" is not SemVer formatted`);
        }
        this.#major = Number.parseInt(match[1]);
        this.#minor = Number.parseInt(match[2]);
        this.#patch = Number.parseInt(match[3]);
    }
    major() {
        this.#major++;
        this.#minor = 0;
        this.#patch = 0;
    }
    minor() {
        this.#minor++;
        this.#patch = 0;
    }
    patch() {
        this.#patch++;
    }
}
//# sourceMappingURL=semver.js.map